import Store from '../../store'
import { generateContent } from '../../setup'
import { coreState } from './core-state'
import coreReducer from './reducer'
import CoreEnums from './enums'
import store from '../../store'

export const handleMenuItemClick = (event) => {
  return generateContent(event.key)
}

export const handleMenuAction = (menu) => {
  switch (menu) {
    case CoreEnums.menuActions.LEFT:
      Store.dispatch(coreReducer.actions.leftMenuOpenClose())
      break
    case CoreEnums.menuActions.RIGHT:
      Store.dispatch(coreReducer.actions.rightMenuOpenClose())
      break
  }
}

export const handleTabAction = (action, key) => {
  switch (action) {
    case CoreEnums.tabActions.CHANGE:
      Store.dispatch(coreReducer.actions.changeTab(key))
      break
    case CoreEnums.tabActions.CLOSE:
      Store.dispatch(coreReducer.actions.closeTab({ targetKey: key, removeBreadcrumb: true }))
      break
    default:
  }
}

export const closeTab = (state, payload) => {
  let tmpActiveKey = null

  if (payload.newTabKey) {
    tmpActiveKey = payload.newTabKey
  } else {
    state.tabNavigation.lastActiveKey = state.tabNavigation.lastActiveKey.filter((key) => key !== payload.targetKey)
    tmpActiveKey =
      state.tabNavigation.lastActiveKey.length > 0
        ? state.tabNavigation.lastActiveKey[state.tabNavigation.lastActiveKey.length - 1]
        : coreState().tabNavigation.rootTabKey
  }

  state.tabNavigation.activeKey = tmpActiveKey
  state.rootContent = () => generateContent(tmpActiveKey).children
}

export const loadContent = (payload, state) => {
  state.tabNavigation.activeKey = payload.key
  state.rootContent = () => payload.children
}

export const manualMenuPop = (key, dispatcher) => {
  if (store.getState().core.tabNavigation.lastActiveKey.length > 0) {
    const targetKey =
      store.getState().core.tabNavigation.lastActiveKey[store.getState().core.tabNavigation.lastActiveKey.length - 1]
    dispatcher(coreReducer.actions.menuItemClick({ key: targetKey, popped: true }))
  }
}
